export default __webpack_public_path__ + "static/media/phone.ca9b55ec.svg";